import {PILOT_CONTRACT_TAKER_FEE} from '@/const/data-config';
import {ContractPair, ContractPerpType, TradeType} from '@/types';

export const contractUtil = {
  isPerpetualContract(type: TradeType) {
    return type === 'Perpetual';
  },
  isPerpetualV2Contract(type: TradeType) {
    return type === 'PerpetualV2';
  },
  isPilotContract(type: ContractPerpType) {
    return type === 'Pilot';
  },
  isNormalContract(type: ContractPerpType) {
    return type === 'Normal' || !type;
  },
  isUSDTPerpetualV2(settleCurrency) {
    return ['MUSDT', 'USDT'].includes(settleCurrency);
  },
  isSupportHedgeMode(type: TradeType) {
    return this.isPerpetualV2Contract(type);
  },
  filterPilotContract(contracts: ContractPair[]) {
    return contracts.filter((o) => this.isPilotContract(o.perpProductSubType));
  },
  filterNormalContract(contracts: ContractPair[]) {
    return contracts.filter((o) => this.isNormalContract(o.perpProductSubType));
  },
  getDefaultTakerFeeRate(contracts: ContractPair, defaultTakerFeeRateEr) {
    return this.isPilotContract(contracts.perpProductSubType) ? PILOT_CONTRACT_TAKER_FEE : defaultTakerFeeRateEr;
  },
  formatterValueFactor(currency, valueFactor) {
    return ['USDC', 'USDT', 'MUSDT', 'PT'].includes(currency) ? 1 : valueFactor;
  },
  formatterValueScale(currency, valueScale) {
    return ['USDC', 'USDT', 'MUSDT', 'PT'].includes(currency) ? 0 : valueScale;
  },
  formatterValuePrecision(currency, valuePrecision) {
    return ['USDC', 'USDT', 'MUSDT', 'PT'].includes(currency) ? valuePrecision : 0;
  },
};
